import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Typography,
  Modal,
  Input,
  notification,
  Image,
  Space,
  Tag,
  Badge,
  Spin,
  Descriptions,
  Tabs,
  Collapse,
  Divider,
  Select,
  Dropdown,
  Menu,
  Checkbox,
  Form,
} from "antd";
import {
  EyeOutlined,
  SearchOutlined,
  SyncOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  ClockCircleOutlined,
  InfoCircleOutlined,
  StarOutlined,
  DollarOutlined,
  CalendarOutlined,
  EnvironmentOutlined,
  PhoneOutlined,
  LinkOutlined,
  TagOutlined,
  UserOutlined,
  GiftOutlined,
  ShopOutlined,
  CrownOutlined,
  FilterOutlined,
  ColumnHeightOutlined,
  SettingOutlined,
  FlagOutlined,
} from "@ant-design/icons";
import React, { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";
import _, { isEmpty } from "lodash";

const { Title, Text } = Typography;
const { TabPane } = Tabs;
const { Option } = Select;
const { TextArea } = Input;

const formatNumber = (num) =>
  !isEmpty(num) ? parseInt(num?.replace(/,/g, "")).toLocaleString() : "0";

const toEuro = (value) => `${parseFloat(value).toFixed(2)} €`;

// Calculate age from date string
const calculateAge = (dateString) => {
  if (!dateString) return "-";

  try {
    const birthDate = moment(dateString);
    if (!birthDate.isValid()) return "-";

    return moment().diff(birthDate, "years");
  } catch (error) {
    console.error("Error calculating age:", error);
    return "-";
  }
};

const Post = () => {
  const [data, setData] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [filtered, setFiltered] = useState(false);
  const [columnsVisible, setcolumnsVisible] = useState(false);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [record, setRecord] = useState(null);
  const [showDetail, setShowDetail] = useState(false);
  const [statusFilter, setStatusFilter] = useState(null);
  const [campaignFilter, setCampaignFilter] = useState(null);
  const [rewards, setRewards] = useState([]);
  const [reportModalVisible, setReportModalVisible] = useState(false);
  const [reportDescription, setReportDescription] = useState("");
  const [reportLoading, setReportLoading] = useState(false);
  const [form] = Form.useForm();
  const [visibleColumns, setVisibleColumns] = useState({
    etablissement: true,
    username: true,
    profileInstagram: true,
    followers: true,
    lienPost: true,
    dateReception: true,
    statut: true,
    nbJoursEnLigne: true,
    mail: true,
    age: false,
    genre: false,
    campagne: true,
    likes: true,
    comments: true,
    tauxEngagement: true,
    score: true,
  });

  const user = JSON.parse(localStorage.getItem("user") || '{"type": "admin"}');

  // Fetch data
  const fetchData = () => {
    setLoading(true);
    axios
      .get("https://trend-me.com/api/Post")
      .then((response) => {
        if (response.data) {
          let sorted_obj = _.sortBy(response.data, (o) => Number(o.id));
          setData(sorted_obj);
        } else {
          notification.error({ message: "No Data Found" });
        }
      })
      .catch((err) => {
        notification.error({ message: "Error loading data" });
        console.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchDataReword = async () => {
    setLoading(true);
    let response =
      user.type === "admin"
        ? await fetch("https://trend-me.com/rewards")
        : await fetch("https://trend-me.com/rewards/ettab/" + user?.IdEtab);
    let data = await response.json();
    setRewards(data);
  };

  const fetchDataByEttab = () => {
    setLoading(true);
    axios
      .get("https://trend-me.com/api/Post/" + user?.IdEtab)
      .then((response) => {
        if (response.data) {
          let sorted_obj = _.sortBy(response.data, (o) => Number(o.id));
          setData(sorted_obj);
        } else {
          notification.error({ message: "No Data Found" });
        }
      })
      .catch((err) => {
        notification.error({ message: "Error loading data" });
        console.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchDataReword();
    if (user?.type === "admin") {
      fetchData();
    } else {
      fetchDataByEttab();
    }
  }, []);

  const handleSearch = (ok) => {
    if (ok) {
      setFiltered(true);
      const filteredData = data.filter((el) => {
        const matchesSearch = el.userId?.username
          .toLowerCase()
          .includes(search.toLowerCase());

        const matchesStatus = statusFilter
          ? el.status.toLowerCase() === statusFilter.toLowerCase()
          : true;

        const matchesCampaign = campaignFilter
          ? el.selectedCampaignName === campaignFilter ||
            el.etablissement?.name === campaignFilter
          : true;

        return matchesSearch && matchesStatus && matchesCampaign;
      });
      setFilterData(filteredData);
    } else {
      setFiltered(false);
      setSearch("");
      setStatusFilter(null);
      setCampaignFilter(null);
      setFilterData([]);
    }
  };

  // Handle report submission
  const handleReportSubmit = () => {
    if (!reportDescription.trim()) {
      notification.error({
        message: "Description requise",
        description: "Veuillez saisir une description pour le signalement",
      });
      return;
    }

    setReportLoading(true);

    // Send report to API
    axios
      .post("https://trend-me.com/Reports", {
        postId: record._id,
        description: reportDescription,
      })
      .then(() => {
        notification.success({
          message: "Signalement envoyé",
          description: "Le post a été signalé avec succès",
        });
        setReportModalVisible(false);
        setReportDescription("");
        form.resetFields();
      })
      .catch((error) => {
        notification.error({
          message: "Erreur",
          description: "Impossible d'envoyer le signalement",
        });
        console.error("Error sending report:", error);
      })
      .finally(() => {
        setReportLoading(false);
      });
  };

  // Open report modal
  const openReportModal = (record) => {
    setRecord(record);
    setReportModalVisible(true);
  };

  const getStatusTag = (status) => {
    const colors = {
      validated: "green",
      valid: "green",
      init: "orange",
      rejected: "red",
    };

    // Normalize status for consistent handling
    const normalizedStatus = status?.toLowerCase() || "unknown";

    let icon = null;
    switch (normalizedStatus) {
      case "validated":
      case "valid":
        icon = <CheckCircleOutlined />;
        break;
      case "init":
        icon = <ClockCircleOutlined />;
        break;
      case "rejected":
        icon = <CloseCircleOutlined />;
        break;
      default:
        icon = <InfoCircleOutlined />;
    }

    return (
      <Tag icon={icon} color={colors[normalizedStatus] || "default"}>
        {status?.toUpperCase() || "UNKNOWN"}
      </Tag>
    );
  };

  const calculateTauxEngagement = (likes, comments, followers) => {
    // Handle various formats and potential missing data
    const likesNum = parseInt((likes || "0").replace(/[^0-9]/g, ""));
    const commentsNum = parseInt((comments || "0").replace(/[^0-9]/g, ""));
    const followersNum = parseInt((followers || "0").replace(/,/g, ""));

    const totalInteractions = likesNum + commentsNum;

    return followersNum > 0
      ? ((totalInteractions / followersNum) * 100).toFixed(2)
      : "0";
  };

  const calculateScore = (post) => {
    if (!post || !post.etablissement || !post.etablissement.scoring) {
      return 0;
    }

    const likes = parseInt((post.likes || "0").replace(/[^0-9]/g, ""));
    const comments = parseInt((post.comments || "0").replace(/[^0-9]/g, ""));
    const followers = parseInt(
      (post.userId?.nbFollowersInsta || "0").replace(/,/g, "")
    );

    const weights = {
      like: parseInt(post.etablissement.scoring.like || 0),
      comment: parseInt(post.etablissement.scoring.comment || 0),
      followers: parseInt(post.etablissement.scoring.followers || 0),
    };

    return (
      likes * weights.like +
      comments * weights.comment +
      followers * weights.followers
    );
  };

  // Get unique campaigns for filter dropdown
  const getUniqueCampaigns = () => {
    const campaigns = data
      .map((item) => item.selectedCampaignName || item.etablissement?.name)
      .filter(Boolean);
    return [...new Set(campaigns)];
  };

  // Column definitions with labels for dropdown menu
  const columnDefinitions = [
    {
      key: "etablissement",
      title: "Établissement",
      dataIndex: ["etablissement", "name"],
      label: "Établissement",
    },
    {
      key: "username",
      title: "Nom d'utilisateur",
      dataIndex: ["userId", "username"],
      label: "Nom d'utilisateur",
    },
    {
      key: "profileInstagram",
      title: "Profil Instagram",
      dataIndex: ["userId", "usernameInsta"],
      label: "Profil Instagram",
    },
    {
      key: "followers",
      title: "Nombre Follower",
      dataIndex: ["userId", "nbFollowersInsta"],
      label: "Nombre Follower",
    },
    {
      key: "lienPost",
      title: "Lien Poste",
      dataIndex: "url",
      render: (url) => (
        <a href={url} target="_blank" rel="noopener noreferrer">
          Voir le post
        </a>
      ),
      label: "Lien Poste",
    },
    {
      key: "dateReception",
      title: "Date réception poste",
      dataIndex: "creationDate",
      render: (text) => {
        try {
          return moment(text, "DD MMM YYYY [à] HH:mm").format("DD/MM/YYYY");
        } catch (e) {
          return text;
        }
      },
      label: "Date réception",
    },
    {
      key: "statut",
      title: "Statut",
      dataIndex: "status",
      render: (text) => getStatusTag(text),
      label: "Statut",
    },
    {
      key: "nbJoursEnLigne",
      title: "Nombre de jours en ligne",
      dataIndex: "",
      render: (_, record) => {
        try {
          // Use validationDate if available, otherwise fallback to creationDate
          const customFormat = "DD MMM YYYY [à] HH:mm";

          const startDate = record.validationDate
            ? moment(record.validationDate, customFormat)
            : moment(record.creationDate, customFormat);
          const currentDate = moment();
          const days = currentDate.diff(startDate, "days");

          // Cap at 30 days as specified in requirements
          return days > 30 ? "30+ jours" : `${days} jours`;
        } catch (e) {
          return "N/A";
        }
      },
      label: "Jours en ligne",
    },
    {
      key: "mail",
      title: "Mail",
      dataIndex: ["userId", "email"],
      label: "Mail",
    },
    {
      key: "age",
      title: "Age",
      dataIndex: ["userId", "date"],
      render: (date) => calculateAge(date),
      label: "Age",
    },
    {
      key: "genre",
      title: "Genre",
      dataIndex: ["userId", "gender"],
      render: (gender) => gender || "-",
      label: "Genre",
    },
    {
      key: "campagne",
      title: "Campagne",
      dataIndex: "selectedCampaignName",
      render: (text, record) => (
        <Button
          type="link"
          onClick={(e) => {
            e.stopPropagation();
            setRecord(record);
            setShowDetail(true);
          }}
        >
          {text || record.etablissement?.name || "-"}
        </Button>
      ),
      label: "Campagne",
    },
    {
      key: "likes",
      title: "Like",
      dataIndex: "likes",
      label: "Like",
    },
    {
      key: "comments",
      title: "Comm.",
      dataIndex: "comments",
      label: "Commentaires",
    },
    {
      key: "tauxEngagement",
      title: "Taux Engagement",
      dataIndex: "",
      render: (_, record) =>
        calculateTauxEngagement(
          record.likes,
          record.comments,
          record.userId?.nbFollowersInsta
        ) + "%",
      label: "Taux Engagement",
    },
    {
      key: "score",
      title: "Score",
      dataIndex: "",
      render: (_, record) => calculateScore(record),
      label: "Score",
    },
  ];

  // Fixed action column that's always visible
  const actionColumn = {
    title: "Actions",
    dataIndex: "",
    key: "actions",
    render: (_, record) => (
      <Space>
        <Button
          shape="circle"
          onClick={() => {
            setRecord(record);
            setShowDetail(true);
          }}
          title="Voir les détails"
        >
          <EyeOutlined />
        </Button>
        <Button
          shape="circle"
          onClick={() => openReportModal(record)}
          title="Signaler ce post"
          type="danger"
        >
          <FlagOutlined />
        </Button>
      </Space>
    ),
  };

  // Generate actual table columns based on visibility settings
  const columns = [
    ...columnDefinitions
      .filter((col) => visibleColumns[col.key])
      .map((col) => ({
        title: col.title,
        dataIndex: col.dataIndex,
        key: col.key,
        render: col.render,
      })),
    actionColumn, // Always add the action column
  ];

  // Handle column visibility toggle with click event prevention
  const handleColumnVisibilityChange = (key, e) => {
    // Prevent the click from closing the dropdown
    e.stopPropagation();
    setVisibleColumns((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  // Select/Deselect all columns with click event prevention
  const handleSelectAllColumns = (selected, e) => {
    // Prevent the click from closing the dropdown
    e.stopPropagation();
    const newVisibility = {};
    Object.keys(visibleColumns).forEach((key) => {
      newVisibility[key] = selected;
    });
    setVisibleColumns(newVisibility);
  };

  // Column visibility dropdown menu with click event prevention
  const columnsMenu = (
    <Menu onClick={(e) => e.domEvent.stopPropagation()}>
      <Menu.Item key="selectAll" onClick={(e) => e.domEvent.stopPropagation()}>
        <Checkbox
          onChange={(e) =>
            handleSelectAllColumns(e.target.checked, e.nativeEvent)
          }
          checked={Object.values(visibleColumns).every((v) => v)}
          onClick={(e) => e.stopPropagation()}
        >
          Tout sélectionner
        </Checkbox>
      </Menu.Item>
      <Menu.Item
        key="deselectAll"
        onClick={(e) => e.domEvent.stopPropagation()}
      >
        <Checkbox
          onChange={(e) =>
            handleSelectAllColumns(!e.target.checked, e.nativeEvent)
          }
          checked={Object.values(visibleColumns).every((v) => !v)}
          onClick={(e) => e.stopPropagation()}
        >
          Tout désélectionner
        </Checkbox>
      </Menu.Item>
      <Menu.Divider />
      {columnDefinitions.map((col) => (
        <Menu.Item key={col.key} onClick={(e) => e.domEvent.stopPropagation()}>
          <Checkbox
            checked={visibleColumns[col.key]}
            onChange={(e) =>
              handleColumnVisibilityChange(col.key, e.nativeEvent)
            }
            onClick={(e) => e.stopPropagation()}
          >
            {col.label}
          </Checkbox>
        </Menu.Item>
      ))}
    </Menu>
  );

  const renderDetailModal = () => {
    if (!record) return null;
    const recompenseOption = record.etablissement?.recompenseOption || {};
    const campaign = record.etablissement || {};

    return (
      <Modal
        title="Détail du Post"
        visible={showDetail}
        onCancel={() => setShowDetail(false)}
        footer={null}
        width={800}
      >
        <Tabs defaultActiveKey="1">
          <TabPane tab="Informations Utilisateur" key="1">
            <Descriptions bordered column={2}>
              <Descriptions.Item label="Nom d'utilisateur">
                {record.userId?.username || "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Profile Instagram">
                {record.userId?.usernameInsta || "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Email">
                {record.userId?.email || "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Téléphone">
                {record.userId?.phone || "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Ville">
                {record.userId?.ville || "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Code Postal">
                {record.userId?.codePostal || "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Date de naissance">
                {record.userId?.date || "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Âge">
                {calculateAge(record.userId?.date) || "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Genre">
                {record.userId?.gender || "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Nombre de followers">
                {record.userId?.nbFollowersInsta || "-"}
              </Descriptions.Item>
            </Descriptions>
          </TabPane>

          <TabPane tab="Récompenses Attribués" key="2">
            <Descriptions bordered column={1}>
              {rewards
                .filter((el) => el.postId._id === record._id)
                .map((elm) => (
                  <Descriptions.Item
                    label={
                      elm.type === "Immédiate"
                        ? "Récompense Immédiate"
                        : `TrendPrize (${elm.type})`
                    }
                  >
                    {elm.title}
                    <Tag color="blue" style={{ marginLeft: 10 }}>
                      {elm.status === "used" ? "Utilisé" : "Non Utilisé"}
                    </Tag>
                  </Descriptions.Item>
                ))}
            </Descriptions>
          </TabPane>

          <TabPane tab="Paramètres Campagne" key="3">
            <Descriptions bordered column={2}>
              <Descriptions.Item label="Nom Campagne" span={2}>
                {campaign.name || record.selectedCampaignName || "Non spécifié"}
              </Descriptions.Item>
              <Descriptions.Item label="Date Début">
                {campaign.dateDebut
                  ? moment(campaign.dateDebut).format("DD/MM/YYYY")
                  : "Non spécifié"}
              </Descriptions.Item>
              <Descriptions.Item label="Date Fin">
                {campaign.dateFin
                  ? moment(campaign.dateFin).format("DD/MM/YYYY")
                  : "Non spécifié"}
              </Descriptions.Item>
              <Descriptions.Item label="Descriptif du challenge" span={2}>
                {campaign.description || "Non spécifié"}
              </Descriptions.Item>
              <Descriptions.Item label="Condition d'accès" span={2}>
                {campaign.nbfollowersMin
                  ? `Minimum ${campaign.nbfollowersMin} followers`
                  : "Non spécifié"}
              </Descriptions.Item>
              <Descriptions.Item label="Budget">
                {campaign.budget ? `${campaign.budget} €` : "Non spécifié"}
              </Descriptions.Item>
              <Descriptions.Item label="Hashtags">
                {campaign.mentionsHashTags || "Non spécifié"}
              </Descriptions.Item>
            </Descriptions>

            <Divider>Scoring</Divider>
            <Table
              dataSource={[
                { name: "Like", value: campaign.scoring?.like || 0 },
                { name: "Commentaire", value: campaign.scoring?.comment || 0 },
                { name: "Follower", value: campaign.scoring?.followers || 0 },
              ]}
              pagination={false}
              rowKey="name"
              columns={[
                { title: "Action", dataIndex: "name" },
                { title: "Point", dataIndex: "value" },
              ]}
            />

            <Divider>Niveaux de Récompense</Divider>
            <Table
              dataSource={[
                {
                  niveau: "BuzzStarter",
                  points: recompenseOption.starterPoints || 0,
                  title: recompenseOption.starterTitle || "-",
                },
                {
                  niveau: "I Make it Trendy",
                  points: recompenseOption.trendyPoints || 0,
                  title: recompenseOption.trendyTitle || "-",
                },
                {
                  niveau: "Pro",
                  points: recompenseOption.proPoints || 0,
                  title: recompenseOption.proTitle || "-",
                },
                {
                  niveau: "SuperStar",
                  points: recompenseOption.superStarPoints || 0,
                  title: recompenseOption.superStarTitle || "-",
                },
              ]}
              pagination={false}
              rowKey="niveau"
              columns={[
                { title: "Niveau", dataIndex: "niveau" },
                { title: "Points", dataIndex: "points" },
                { title: "Récompense", dataIndex: "title" },
              ]}
            />
          </TabPane>
        </Tabs>
      </Modal>
    );
  };

  // Report modal
  const renderReportModal = () => {
    return (
      <Modal
        title={
          <Space>
            <FlagOutlined style={{ color: "#ff4d4f" }} />
            <span>Signaler ce post</span>
          </Space>
        }
        visible={reportModalVisible}
        onCancel={() => {
          setReportModalVisible(false);
          setReportDescription("");
          form.resetFields();
        }}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              setReportModalVisible(false);
              setReportDescription("");
              form.resetFields();
            }}
          >
            Annuler
          </Button>,
          <Button
            key="submit"
            type="primary"
            danger
            onClick={handleReportSubmit}
            loading={reportLoading}
          >
            Signaler
          </Button>,
        ]}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="description"
            label="Description du signalement"
            rules={[
              {
                required: true,
                message: "Veuillez décrire la raison du signalement",
              },
            ]}
          >
            <TextArea
              rows={4}
              placeholder="Décrivez la raison du signalement..."
              value={reportDescription}
              onChange={(e) => setReportDescription(e.target.value)}
            />
          </Form.Item>
          {record && (
            <Descriptions
              title="Informations sur le post"
              size="small"
              bordered
            >
              <Descriptions.Item label="Utilisateur" span={3}>
                {record.userId?.username || "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Profil Instagram" span={3}>
                {record.userId?.usernameInsta || "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Lien du post" span={3}>
                <a href={record.url} target="_blank" rel="noopener noreferrer">
                  {record.url || "-"}
                </a>
              </Descriptions.Item>
            </Descriptions>
          )}
        </Form>
      </Modal>
    );
  };

  return (
    <div style={{ padding: 24 }}>
      <Row gutter={[24, 24]}>
        <Col span={24}>
          <Card
            bordered={false}
            title={<Title level={4}>Instagram Posts Dashboard</Title>}
            extra={
              <Space>
                <Input
                  placeholder="Search by username..."
                  prefix={<SearchOutlined />}
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  onPressEnter={() => handleSearch(true)}
                  style={{ width: 200 }}
                />
                <Select
                  placeholder="Filter by status"
                  allowClear
                  style={{ width: 150 }}
                  onChange={(value) => setStatusFilter(value)}
                  value={statusFilter}
                >
                  <Option value="valid">Valid</Option>
                  <Option value="init">Init</Option>
                  <Option value="rejected">Rejected</Option>
                </Select>
                <Select
                  placeholder="Filter by campaign"
                  allowClear
                  style={{ width: 200 }}
                  onChange={(value) => setCampaignFilter(value)}
                  value={campaignFilter}
                >
                  {getUniqueCampaigns().map((camp) => (
                    <Option key={camp} value={camp}>
                      {camp}
                    </Option>
                  ))}
                </Select>
                <Button
                  type="primary"
                  icon={<FilterOutlined />}
                  onClick={() => handleSearch(true)}
                >
                  Filter
                </Button>
                <Button onClick={() => handleSearch(false)}>Reset</Button>
                <Button
                  icon={<SyncOutlined />}
                  onClick={() =>
                    user?.type === "admin" ? fetchData() : fetchDataByEttab()
                  }
                >
                  Refresh
                </Button>
              </Space>
            }
          >
            {/* Column visibility dropdown */}
            <div
              style={{
                marginBottom: 16,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Text strong>
                Total: {(!filtered ? data : filterData).length} posts
              </Text>
              <Dropdown
                overlay={columnsMenu}
                trigger={["click"]}
                placement="bottomRight"
                visible={columnsVisible}
                onVisibleChange={setcolumnsVisible}
              >
                <Button icon={<SettingOutlined />}>
                  Afficher/Masquer les colonnes
                </Button>
              </Dropdown>
            </div>

            <Table
              dataSource={!filtered ? data : filterData}
              columns={columns}
              rowKey={(record) => record._id || Math.random().toString()}
              scroll={{ x: true }}
              loading={loading}
              pagination={{
                pageSize: 10,
                showSizeChanger: true,
                showTotal: (total) => `Total ${total} posts`,
              }}
            />
          </Card>
        </Col>
      </Row>

      {renderDetailModal()}
      {renderReportModal()}
    </div>
  );
};

export default Post;
